import { Component } from '@angular/core';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonSearchbar, IonLabel } from '@ionic/angular/standalone';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { Relationship, RelationshipService } from '../../modules/relationship';
import { activeAccountChanges } from '../../modules/authentication';
import { PaginatedResponse } from '../../interface/PaginatedResponse';
import { Router } from '@angular/router';
import { SexyModule } from '@qid/sexy';
import { AvatarRoundComponent, PaginationBoxComponent } from '@qid/super';
import { FormatPhonePipe } from '../../pipes/format-phone.pipe';
import { IonIcon, IonSpinner } from '@ionic/angular/standalone';

@Component({
    selector: 'app-list-customers',
    templateUrl: './list-customers.page.html',
    styleUrls: ['./list-customers.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        SexyModule,
        AvatarRoundComponent,
        PaginationBoxComponent,
        FormatPhonePipe,
        IonHeader,
        IonToolbar,
        IonTitle,
        IonContent,
        IonSearchbar,
        IonLabel,
        IonIcon,
        IonSpinner
    ],
})
export class ListCustomersPage {

    paginatedCustomers: PaginatedResponse<Relationship> = null;
    isLoading: boolean = false;
    searchInput: any;

    private pageClosed$ = new Subject<void>();

    constructor(
        private relationshipService: RelationshipService,
        private router: Router,
        private store: Store
    ) { }

    ionViewDidEnter() {
        this.pageClosed$ = new Subject<void>();
        activeAccountChanges(this.store)
            .pipe(takeUntil(this.pageClosed$))
            .subscribe(() => this.loadCustomers());
    }

    ionViewDidLeave() {
        this.pageClosed$.next();
        this.pageClosed$.complete();
    }

    async loadCustomers(page: number = 1) {
        this.isLoading = true;
        try {
            const response = await this.relationshipService.readAllCustomers(page, this.searchInput);
            if (response && response.data) {
                this.paginatedCustomers = response.data;
            }
        } finally {
            this.isLoading = false;
        }
    }

    search() {
        this.loadCustomers();
    }

    refresh(event: any) {
        this.loadCustomers();
        event.target.complete();
    }

    viewCustomer(customerId: string) {
        this.router.navigate(['/menu/customers', customerId]);
    }

    openEmail(email: string) {
        if (email) window.open(`mailto:${email}`, '_blank');
    }

    openCall(phone: string) {
        if (phone) window.open(`tel:${phone}`, '_self');
    }

    openWhatsApp(phone: string) {
        if (!phone) return;
        const digits = phone.replace(/\D/g, '');
        window.open(`https://wa.me/${digits}`, '_blank');
    }
} 